import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "207",
  height: "207",
  viewBox: "0 0 104 104",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M48 .04A52 52 0 0 0 .07 47.9h7A45 45 0 0 1 47.98 7.07L48 .04ZM48 96.73A45 45 0 0 1 7 54.9H0a52 52 0 0 0 48 48.85v-7.02ZM55 103.81v-7a45 45 0 0 0 41.82-41.89h7A52 52 0 0 1 55 103.81ZM55 7V0a52 52 0 0 1 48.76 47.91h-7A45 45 0 0 0 55 7Z",
  fill: "#D5D4D6"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M85 51.5C85 70.001 70.001 85 51.5 85 32.998 85 18 70.001 18 51.5 18 32.998 32.998 18 51.5 18 70.001 18 85 32.998 85 51.5Z",
  fill: "#E54666",
  stroke: "#FF6D8A",
  "stroke-width": "6"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M49 39h4.931l-.896 17.931h-3.138L49 39Zm4.828 25h-4.725v-4.414h4.725V64Z",
  fill: "#fff"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5))
}
export default { render: render }